import { RouteButton } from "../../Buttons"
import { GenericTableFactory } from "@/components/_Shared/Table/Classes/Factory"

export default function ViewRFI() {
    const table = GenericTableFactory.createRFITable("all")
    return (
        <>
            <div className="pt-5 pl-5">
                <h1>RFIs</h1>
            </div>
                
            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}

export function UsersRFIList() {
    const table = GenericTableFactory.createRFITable("personal")
    return (
        <>
            <div className="pt-5 pl-5">
                <h1>RFIs</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}

